<template>
  <div
    class="reaction-detail-container d-flex justify-center"
    style="width: 100%;"
  >
    <BackTop></BackTop>
    <div class="reaction-detail d-flex align-center flex-column justify-start">
      <transition name="trans">
        <div class="svg-container" v-if="showAllSvg">
          <div class="all-center px-5">
            <div>
              <div
                class="reactants-wrapper"
                style="float: left; height: 220px;"
                v-for="(item, index) in reactionArr.reactants"
                @click="getDetail('reactant', item.smilesId, item.svgStr)"
              >
                <div class="all-center">
                  <div
                    v-html="item.svgStr"
                    :ref="item.id"
                    class="indigo-svg-wrapper d-flex justify-center"
                    style="max-width: 170px; overflow: hidden;"
                  ></div>

                  <div
                    v-show="reactionArr.reactants.length - 1 !== index"
                    class="all-center"
                    style="padding: 8px; height: 120px;"
                  >
                    <v-icon color="#333">mdi-plus</v-icon>
                  </div>
                </div>
              </div>
              <div
                class="d-inline-block mr-8 ml-4"
                style="
                  float: left;
                  position: relative;
                  min-width: 50px;
                  height: 220px;
                "
              >
                <div
                  class="arrow pr-8 pl-4"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                    height: 2px;
                    background: #333;
                    width: 100%;
                    min-width: 50px;
                  "
                ></div>
                <div
                  class="catalyst-wrapper d-flex justify-center align-start"
                  @click="getDetail('catalyst', item.smilesId, item.svgStr)"
                  style="float: left; height: 220px;"
                  v-for="(item, index) in reactionArr.catalyst"
                >
                  <div
                    v-html="item.svgStr"
                    :ref="item.id"
                    class="indigo-svg-wrapper catalyst-svg"
                    style="max-width: 170px; height: 120px;"
                  ></div>
                </div>
              </div>

              <div
                class="generating-wrapper"
                style="float: left; height: 220px;"
                @click="getDetail('generating', item.smilesId, item.svgStr)"
                v-for="(item, index) in reactionArr.generating"
              >
                <div class="all-center">
                  <div
                    v-html="item.svgStr"
                    :ref="item.id"
                    class="indigo-svg-wrapper d-flex justify-center"
                  ></div>
                  <div
                    v-if="reactionArr.generating.length - 1 !== index"
                    class="px-2"
                  >
                    <v-icon color="#333">mdi-plus</v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              width: 100%;
              font-size: 14px;
              height: 50px;
              border-top: 1px solid #f5f5f5;
            "
            class="d-flex justify-center"
          >
            <div class="all-center px-2" style="float: left;">
              <div v-for="(str, index) in formulaArr[0]" class="all-center">
                {{ str }}
                <div v-if="index !== formulaArr[0].length - 1" class="px-1">
                  +
                </div>
              </div>
            </div>
            <div
              style="float: left; position: relative; min-width: 40px;"
              class="d-flex justify-start align-start"
            >
              <div class="px-2" v-for="str in formulaArr[1]">{{ str }}</div>

              <div
                class="arrow"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 100%;
                  transform: translate(-50%, -50%);
                  height: 2px;
                  background: black;
                  margin-right: 20px;
                "
              ></div>
            </div>

            <div class="all-center px-6" style="float: left;">
              <div class="all-center" v-for="(str, index) in formulaArr[2]">
                {{ str }}
                <div class="px-1" v-if="index !== formulaArr[2].length - 1">
                  <div>+</div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="description all-center"
            v-if="formulaArr[1].length || yield1"
            style="border-top: 1px solid #f5f5f5;"
          >
            <div
              class="catalyst text-center flex-grow-1"
              v-show="formulaArr[1].length"
            >
              <span>{{ $i18n.t("catalyst") }} : </span>
              <span v-for="item in formulaArr[1]" class="px-2">{{ item }}</span>
            </div>
            <div
              style="text-align: center; height: 100%; flex-grow: 1;"
              v-if="yield1"
            >
              {{ $i18n.t("yield") }}: {{ yield1 }}
            </div>
          </div>
        </div>
      </transition>

      <div
        class="d-flex justify-start align-center"
        style="width: 100%; margin-top: 20px;"
      >
        <h2 style="width: 50%;" class="text-left">{{ formula }}</h2>
        <transition name="fade">
          <h2
            v-if="detail.properties && detail.properties.length"
            style="width: 50%; padding-left: 10px;"
            class="text-left"
          >
            {{ $i18n.t("detail.properties") }}
          </h2>
        </transition>
      </div>

      <div
        class="SvgAndProtypes d-flex justify-space-between bigSvg"
        style="width: 100%;"
      >
        <div
          style="width: 100%; height: 650px; border: 1px solid #999999;"
          v-html="svgStr"
          class="all-center svg-wrapper"
        ></div>
        <transition name="fade">
          <div
            class="prototypes"
            v-if="detail.properties && detail.properties.length"
            style="height: 650px; margin-left: 20px;"
          >
            <div
              class="prototypes-item d-flex flex-grow-1"
              style="width: 648px;"
              v-for="calculate in detail.properties"
              :key="calculate.type"
            >
              <div class="prototypes-item-left" style="width: 65%;">
                {{ $i18n.t(`detail.${calculate.key}`) }}
              </div>
              <div
                class="prototypes-item-right"
                style="width: 35%; overflow: hidden;"
              >
                {{ calculate.value }}{{ calculate.unit }}
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div
        class="other-propotypes"
        v-show="detail.details && detail.details.length"
        style="width: 100%; margin-top: 20px;"
      >
        <h2 class="mb-1">{{ $i18n.t("detail.identify_information") }}</h2>
        <div class="prototypes">
          <div
            class="prototypes-item"
            v-for="(item, index) in detail.details"
            :key="item.key + index"
            style="height: 32px;"
          >
            <div class="prototypes-item-left" style="width: 20%;">
              {{ item.key }}
            </div>
            <div
              class="prototypes-item-right"
              style="width: 80%; white-space: nowrap; overflow: hidden;"
            >
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="contentBriefs && contentBriefs.length > 0"
        class="second-reaction-container"
        style="width: 100%; margin-top: 40px;"
      >
        <h2>{{ $i18n.t("detail.related_reactions") }}</h2>
        <div
          v-for="(item, index) in contentBriefs"
          :key="index"
          style="padding-bottom: 40px; display: flex; justify-content: center;"
        >
          <SmilesItem
            style="
              width: 100% !important;
              min-width: 1320px;
              max-height: 1320px;
            "
            :yield1="item.yield"
            :index="index"
            :str="item"
          ></SmilesItem>
        </div>
        <v-progress-linear
          indeterminate
          background-color="#f9f9f9"
          color="#999 "
          v-if="isLoading"
          class="mb-4"
        ></v-progress-linear>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ReactionDeatil",
  data() {
    return {
      svgStr: "",
      formula: "",
      formulaArr: [],
      reactionArr: {
        reactants: [],
        catalyst: [],
        generating: [],
      },
      yield1: "",
      conditions: {
        type: "",
        smilesId: "",
        index: 1,
      },
      contentBriefs: [],
      currentPage: 1,
      pageTotal: 0,
      showSecondReaction: false,
      isLoading: false,
      showAllSvg: false,
    };
  },
  components: {},
  created() {
    this.changeSmileToSvg(
      JSON.parse(
        window.sessionStorage.getItem(this.$route.query.str)
      ).smiles.replace(new RegExp(" ", "gm"), "")
    ).then((res) => {
      let a1 = "a" + this.createRandomId();
      let a2 = "a" + this.createRandomId();
      let a3 = "a" + this.createRandomId();
      let a4 = "a" + this.createRandomId();
      let a5 = "a" + this.createRandomId();
      let a6 = "a" + this.createRandomId();
      let a7 = "a" + this.createRandomId();
      let a8 = "a" + this.createRandomId();
      let a9 = "a" + this.createRandomId();
      let svgStr = res.data
        .replace(new RegExp("glyph0", "gm"), a1)
        .replace(new RegExp("glyph1", "gm"), a2)
        .replace(new RegExp("glyph2", "gm"), a3)
        .replace(new RegExp("glyph3", "gm"), a4)
        .replace(new RegExp("glyph4", "gm"), a5)
        .replace(new RegExp("glyph5", "gm"), a6)
        .replace(new RegExp("glyph6", "gm"), a7)
        .replace(new RegExp("glyph7", "gm"), a8)
        .replace(new RegExp("glyph8", "gm"), a9);
      this.svgStr = svgStr;
    });
    this.conditions = {
      index: 1,
      smilesId: this.$route.query.smilesId,
      type: this.$route.query.type,
    };
    this.getReactionDetail(this.conditions).then((res) => {
      if (res.data.code === 604) {
        this.$router.push("/");
      }
      this.pageTotal = res.data.data.pageTotal;
      this.contentBriefs = this.briefs;
      this.smilesToFormula({ smiles: this.detail.details[0].value }).then(
        (res) => {
          this.formula = res.data.replace(new RegExp(" ", "gm"), "");
        }
      );
    });
  },
  mounted() {
    this.str = JSON.parse(window.sessionStorage.getItem(this.$route.query.str));
    this.yield1 = this.str.yield;
    let reactants = this.uniqueArr(this.str.reactants) || [];
    let catalysts = this.uniqueArr(this.str.catalysts) || [];
    let products = this.uniqueArr(this.str.products) || [];
    this.oldArr = reactants.length + catalysts.length + products.length;

    let str1 = this.arrToStr(reactants);
    let str2 = this.arrToStr(catalysts);
    let str3 = this.arrToStr(products);
    this.ConcatSmiles = str1 + ">" + str2 + ">" + str3;

    this.changeSmilesToFormula(
      this.ConcatSmiles.replace(new RegExp(" ", "gm"), "")
    );
    this.changeSvgStyle(reactants, this.reactionArr.reactants, 1);
    this.changeSvgStyle(catalysts, this.reactionArr.catalyst, 2);
    this.changeSvgStyle(products, this.reactionArr.generating, 3);

    setTimeout(() => {
      let res = document.querySelectorAll(".indigo-svg-wrapper");
      for (let i = 0; i < res.length; i++) {
        let width = res[i].children[0].getAttribute("width");
        if (width.split("pt")[0] > 900) {
          res[i].style.width = "170px";
        } else if (width.split("pt")[0] > 800) {
          res[i].style.width = "150px";
        } else if (width.split("pt")[0] > 600) {
          res[i].style.width = "130px";
        } else if (width.split("pt")[0] > 400) {
          res[i].style.width = "110px";
        } else if (width.split("pt")[0] > 240) {
          res[i].style.width = "90px";
        } else if (width.split("pt")[0] > 120) {
          res[i].style.width = "70px";
        } else if (width.split("pt")[0] > 85) {
          res[i].style.width = "50px";
        } else if (width.split("pt")[0] > 50) {
          res[i].style.width = "35px";
        } else {
          res[i].style.width = "20px";
        }
      }
    }, 800);

    window.onscroll = () => {
      //文档内容实际高
      let scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      //滚动条滚动距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //窗口可视范围高度
      let clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );

      if (clientHeight + scrollTop >= scrollHeight) {
        this.conditions.index = this.conditions.index + 1;
        console.log(this.conditions);
        if (this.currentPage < this.pageTotal) {
          this.isLoading = true;
          this.getReactionDetail(this.conditions).then((res) => {
            this.currentPage = this.currentPage + 1;
            this.contentBriefs = this.contentBriefs.concat(this.briefs);
            this.isLoading = false;
            this.smilesToFormula({ smiles: this.detail.details[0].value }).then(
              (res) => {
                this.formula = res.data.replace(new RegExp(" ", "gm"), "");
              }
            );
          });
        }
      }
    };
  },
  computed: {
    ...mapState(["detail", "briefs"]),
  },
  methods: {
    ...mapActions([
      "getReactionDetail",
      "smilesToFormula",
      "smilesToSvg",
      "reactionToFormula",
    ]),
    getDetail(type, smilesId, svgStr) {
      this.svgStr = svgStr;
      this.conditions = { type, smilesId, index: 1 };
      this.contentBriefs = [];
      this.getReactionDetail(this.conditions).then((res) => {
        if (res.data.code === 604) {
          this.$router.push("/");
        }
        this.currentPage = 1;
        this.pageTotal = res.data.data.pageTotal;
        this.contentBriefs = res.data.data.reactionVoItems;
        this.smilesToFormula({ smiles: this.detail.details[0].value }).then(
          (res) => {
            this.formula = res.data.replace(new RegExp(" ", "gm"), "");
          }
        );
      });
    },
    arrToStr(arr) {
      let str = "";
      for (let i = 0; i < arr.length; i++) {
        if (i === arr.length - 1) {
          str = str + arr[i].smiles;
        } else {
          str = str + arr[i].smiles + ".";
        }
      }
      return str;
    },
    changeSmileToSvg(smiles) {
      return this.smilesToSvg({ smiles });
    },
    changeSmilesToFormula(smiles) {
      this.reactionToFormula({ smiles }).then((res) => {
        this.formulaArr.push(Array.from(new Set(res.data[0])));
        this.formulaArr.push(Array.from(new Set(res.data[1])));
        this.formulaArr.push(Array.from(new Set(res.data[2])));
        this.showFormula = true;
      });
    },
    changeSvgStyle(old, newV, index) {
      // 原始数组  新生成的svg数组
      if (old.length === 0) return;
      for (let i = 0; i < old.length; i++) {
        this.changeSmileToSvg(
          old[i].smiles.replace(new RegExp(" ", "gm"), "")
        ).then((res) => {
          let a1 = "a" + this.createRandomId();
          let a2 = "a" + this.createRandomId();
          let a3 = "a" + this.createRandomId();
          let a4 = "a" + this.createRandomId();
          let a5 = "a" + this.createRandomId();
          let a6 = "a" + this.createRandomId();
          let a7 = "a" + this.createRandomId();
          let a8 = "a" + this.createRandomId();
          let a9 = "a" + this.createRandomId();
          let a10 = "a" + this.createRandomId();
          let svgStr = res.data
            .replace(new RegExp("glyph0", "gm"), a1)
            .replace(new RegExp("glyph1", "gm"), a2)
            .replace(new RegExp("glyph2", "gm"), a3)
            .replace(new RegExp("glyph3", "gm"), a4)
            .replace(new RegExp("glyph4", "gm"), a5)
            .replace(new RegExp("glyph5", "gm"), a6)
            .replace(new RegExp("glyph6", "gm"), a7)
            .replace(new RegExp("glyph7", "gm"), a8)
            .replace(new RegExp("glyph8", "gm"), a9)
            .replace(new RegExp("glyph9", "gm"), a10);
          newV.push({
            svgStr: svgStr,
            smilesId: old[i].smilesId,
            id: "reactants" + i + this.index,
            smiles: old[i].smiles,
          });
          if (index === 3 && newV.length === old.length) {
            this.showAllSvg = true;
          }
          setTimeout(() => {
            let res = document.querySelectorAll(".indigo-svg-wrapper");
            for (let i = 0; i < res.length; i++) {
              let width = res[i].children[0].getAttribute("width");
              if (width.split("pt")[0] > 900) {
                res[i].style.width = "170px";
              } else if (width.split("pt")[0] > 800) {
                res[i].style.width = "150px";
              } else if (width.split("pt")[0] > 600) {
                res[i].style.width = "130px";
              } else if (width.split("pt")[0] > 400) {
                res[i].style.width = "110px";
              } else if (width.split("pt")[0] > 240) {
                res[i].style.width = "90px";
              } else if (width.split("pt")[0] > 120) {
                res[i].style.width = "70px";
              } else if (width.split("pt")[0] > 85) {
                res[i].style.width = "50px";
              } else if (width.split("pt")[0] > 50) {
                res[i].style.width = "35px";
              } else {
                res[i].style.width = "20px";
              }
            }
          });
        });
      }
    },
    createRandomId() {
      return (
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random().toString().substr(2, 5)
      );
    },
    uniqueArr(arr) {
      let result = {};
      let finalResult = [];
      for (let i = 0; i < arr.length; i++) {
        result[arr[i].smilesId] = arr[i];
      }
      for (let item in result) {
        finalResult.push(result[item]);
      }
      return finalResult;
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  width: 650px;
  transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  width: 0;
}
.trans-enter-active,
.trans-leave-active {
  transition: all 1s ease;
  transform: translateY(0);
}

.trans-enter,
.trans-leave-to {
  transform: translateY(-200px);
}

.bigSvg > .all-center > svg {
  max-width: 640px;
}

.reaction-detail {
  max-width: 1360px;
  min-width: 1360px;
  background: white;
  margin: 20px;
  padding: 20px;
}

.svg-container {
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  -webkit-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0 2px 0px rgba(0, 0, 0, 0.5);
  width: 100%;
  justify-content: flex-end;
  align-items: center;
}

.indigo-svg-wrapper > svg {
  height: 220px;
  width: 100%;
  max-width: 170px;
}

div.catalyst-svg > svg {
  height: 110px;
}

.description {
  text-align: left;
  padding: 10px;
  width: 100%;
  display: flex;
  align-items: flex-start;

  .cui-itmes-wrapper {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 50%;
  }
}

.arrow::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 100%;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 18px solid transparent;
  border-left: 18px solid black;
}

.prototypes {
  display: flex;
  flex-direction: column;
  border: 1px solid;
  border-bottom: transparent;

  .prototypes-item {
    display: flex;
    align-items: center;
    flex-grow: 1;
    height: 32px;
    border-bottom: 1px solid;

    &-left {
      height: 100%;
      justify-content: center;
      display: flex;
      align-items: center;
      width: 50%;
      border-right: 1px solid;
    }

    &-right {
      display: flex;
      width: 50%;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
